import { useRef } from "react";
import { LoaderCircle } from "lucide-react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { usePlatformAuth } from "../../lib/use-platform-auth";

export function RequireSession() {
  const location = useLocation();
  const { sessionData, isPending, bootstrapLoading, profile } = usePlatformAuth();
  const hasRenderedRef = useRef(false);

  // Once children have mounted, keep them mounted through background session
  // revalidations (e.g. on tab focus) so in-progress form state isn't wiped.
  if (hasRenderedRef.current) {
    if (!isPending && !sessionData?.user) {
      return <Navigate to="/auth/login" replace state={{ from: location.pathname }} />;
    }
    return <Outlet />;
  }

  if (isPending || (sessionData?.user && bootstrapLoading && !profile)) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <LoaderCircle className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!sessionData?.user) {
    return <Navigate to="/auth/login" replace state={{ from: location.pathname }} />;
  }

  hasRenderedRef.current = true;
  return <Outlet />;
}
